import BApp from "../../modules/BApp";
import BRequest from "../../modules/BRequest";
import BDiaryDayMealForm from "./BDiaryDayMealForm";
import BDiaryDaySearch from "./BDiaryDaySearch";

export default class BDiaryDayMealSearch extends BDiaryDaySearch
{
	getDiaryDayMealForm()
	{
		return new BDiaryDayMealForm(this.el.closest(".profile-diary-day-meal-form"));
	}

	setResults(results)
	{
		const resultsEl = this.getResultsElement();
		resultsEl.innerHTML = "";

		if (results.length === 0) {
			resultsEl.innerHTML = `<div class="b-dropdown__empty">Nic nenalezeno</div>`;
			this.showResults();
			return;
		}

		for (let result of results) {
			const item = document.createElement("div");
			item.className = "b-dropdown__option";
			item.dataset.id = result.id;

			if (result.imageUrl) {
				const img = document.createElement("img");
				img.src = result.imageUrl;
				img.className = "b-dropdown__option-img";
				img.alt = "";
				img.loading = "lazy";
				item.appendChild(img);
			}

			const label = document.createElement("span");
			label.className = "b-dropdown__option-label";
			label.textContent = result.name;
			item.appendChild(label);

			resultsEl.appendChild(item);
		}

		this.showResults();
	}

	addIngredient(ingredientId)
	{
		const diaryDayMealForm = this.getDiaryDayMealForm();
		const url = this.getAddUrl();
		const data = {
			...diaryDayMealForm.getForm().getData(),
			diaryDayMealId: diaryDayMealForm.getDiaryDayMealId(),
			ingredientId: ingredientId,
		};

		this.resetTerm();
		this.hideResults();
		diaryDayMealForm.setLoading();

		BRequest.post(url, data).then(response => {
			diaryDayMealForm.addEntryHtml(response.data.templates.diaryDayMealIngredient);
			diaryDayMealForm.updateValues(response.data.values);
			diaryDayMealForm.focusLastEntryAmount();
		}).finally(() => {
			diaryDayMealForm.unsetLoading();
			BApp.refresh();
		});
	}

	createEntry(diaryDaySearchResult)
	{
		this.addIngredient(diaryDaySearchResult.getObjectId());
	}
}
